import React from 'react';
import MainConfig from './MainConfig';
import AxisConfig from '../AxisConfig';
import SeriesConfig from '../SeriesConfig';
import LegendControl from '../LegendControl';

export const DEFAULT_CONFIGURATION = {
  chartTitle: '',
  curve: 'linear',
  legendAnchor: 'bottom-right',
  showLabels: false,
  plotNulls: false,
  horizontalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  verticalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  scale: 1,
  axisPrefix: null,
  axisSuffix: null,
  secondaryAxisPrefix: null,
  secondaryAxisSuffix: null,
  minValue: null,
  maxValue: null,
  useDataColor: true,
  colors: {},
  backgroundColor: 'transparent',
  gridColor: 'transparent',
};

function LineChartConfiguration({ meta, horizontalSortType }) {
  return (
    <>
      <MainConfig meta={meta} />
      <LegendControl meta={meta} />
      <AxisConfig axis='horizontal' showSort sortType={horizontalSortType} />
      <AxisConfig axis='vertical' active />
      <SeriesConfig meta={meta} />
    </>
  );
}

export default LineChartConfiguration;
